import { WeekDays } from '@agilox/ui-common';

export const WeekDayNumbers = Object.values(WeekDays).filter((key) => typeof key === 'number');
